import { Card, Heading } from '~/components/granular';
import type { FormSectionProps } from '.';

export function FormSection({ title, children, className, ...props }: FormSectionProps) {
  return (
    <fieldset aria-label={title} className={className}>
      <div className="flex w-full flex-col gap-3">
        <Heading as="h4" className="text-neutral-800">
          {title}
        </Heading>
        <Card className="p-6" {...props}>
          <div className="flex w-full flex-col gap-3">{children}</div>
        </Card>
      </div>
    </fieldset>
  );
}
